// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    PLAYLIST_PAGE_LOADING() {
      return {
        isLoading: true
      };
    },
    PLAYLIST_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';

      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        {},
        'videoPlaylistPage'
      );
      return {
        isLoading: false,
        data: action.jwPlaylist,
        ads: adModelData
      };
    },
    PLAYLIST_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.jwPlaylist.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
